<template>
  <div v-if="imageLink">
    <a v-if="isActionButtonWebURL" :href="imageLink.url" target="_blank" rel="noopener noreferrer noindex">
      <slot />
    </a>
    <router-link v-else-if="deepLinkRoute" :to="deepLinkRoute">
      <slot />
    </router-link>
    <div v-else @click="$eventBus.$emit('notify', $translate('PostImageWrapper.downloadApp'))">
      <slot />
    </div>
  </div>
</template>

<script>
import * as urls from "@/services/urls.js"

export default {
  props: {
    postId: {
      type: Number,
      required: true
    },
    imageLink: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    isActionButtonWebURL() {
      return urls.isValid(this.imageLink.url)
    },
    deepLinkRoute() {
      return urls.getRouterRouteFromDeepLink(this.imageLink.url)
    }
  }
}
</script>
